<template>
  <div>
    <oil-form
      :title='title'
      :keys='keys'
      :items='product'
      :createForm='!id'
      :success-message='message'
      :formCallback='formCallBack'
    >
    </oil-form>
  </div>
</template>
<script>
import { productsService } from '@/services/ProductsService'
import { formKeys, formTitle } from './setting/ProductHelper.js'
import { Product } from '@/model/Product'
import {notify} from '~/services/NOTIFY'
import Vue from 'vue'

export default {
  props: {
    id: {
      type: String
    }
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },

  data: () => ({
    title: '',
    isCreate: true,
    keys: formKeys,
    product: new Product(),
    rule: [],
    count:{
      count: 0
    }
  }),
  async created() {
    if (this.id) {
      const product = await productsService.getById(this.id)
      this.product.change(product.data)
      this.isCreate = false
    }
    this.title = formTitle(!this.id)
  },
  computed: {
    storeType() {
      return this.isCreate ? productsService.create : productsService.update
    },

    message() {
      return this.id ? 'поздравлаем товар удачно изменен' : 'поздравлаем товар удачно создан'
    }

  },

  methods: {
    fii(asd) {
      return asd
    },
    async formCallBack(data) {

      const store = this.storeType
      const response = await store(data)
      if (!response.data) return
      this.product.change(response.data)
      if (this.id) {
        notify('товар удачно изменен')
      }else {
        notify('товар удачно создан')
      }
      await this.$router.push(`/products`)
    }
  },
  watch: {}


}
</script>
